import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FindMarkupByChannelPipe } from './find-markup-by-channel.pipe';
import { ListingMarkupPipe } from './listing-markup.pipe';
import { Markup, MarkupsService, PlatformMarkup } from '@app/features/pricing-and-availability';
import { UiModule } from '@app/ui/ui.module';
import { TranslocoRootModule } from 'src/app/transloco-root.module';

@Component({
  standalone: true,
  selector: 'sbnb-property-listing-markups',
  templateUrl: './property-listing-markups.component.html',
  styleUrls: ['./property-listing-markups.component.scss'],
  imports: [CommonModule, FormsModule, UiModule, FindMarkupByChannelPipe, ListingMarkupPipe, TranslocoRootModule],
})
export class PropertyListingMarkupsComponent implements OnInit {
  @Input() property: any;
  saveStatus: number;
  markups: Markup[];
  platformMarkups: PlatformMarkup[];

  constructor(private readonly markupsService: MarkupsService) {}

  ngOnInit(): void {
    this.markupsService.getPropertyMarkups(this.property.id).subscribe((res) => {
      this.markups = res;
    });

    this.markupsService.getPlatformMarkups().subscribe((res) => {
      this.platformMarkups = res;
    });
  }

  listingMarkupChanged(listing, newValue) {
    const payload: Markup = {
      platform: listing.unified_platform_key,
      markup: newValue.length > 0 ? newValue / 100 : null,
      listing_id: listing.listing_id,
    };
    this.saveStatus = 1;
    this.markupsService.updatePropertyMarkups(this.property.id, payload).subscribe((res) => {
      this.saveStatus = 2;
      setTimeout(() => {
        this.saveStatus = 0;
      }, 2000);
    });
  }
}
